/* Mr Mattress 365 night trial page. Fade in on scroll + sticky "Choose your mattress" button.
   No libraries. If this file never loads, nothing is hidden and the sticky button simply stays on screen. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rv = [].slice.call(d.querySelectorAll('.t365-rv'));
  var hasIO = 'IntersectionObserver' in window;

  // Reveal on scroll. Anything already in view is marked in before the hidden state is switched on, so nothing flashes.
  if (rv.length) {
    if (!hasIO || reduce) {
      rv.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var vh = window.innerHeight || 800;
      rv.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) e.classList.add('is-in'); });
      root.classList.add('t365-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      rv.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
    }
  }

  // Sticky button: visible everywhere except while the product tiles or the closing buttons are on screen.
  var sticky = d.querySelector('[data-t365-sticky]');
  if (sticky && hasIO) {
    var live = {}, n = 0;
    function update() { sticky.classList.toggle('is-off', Object.keys(live).some(function (k) { return live[k]; })); }
    function watch(els, threshold) {
      var o = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { live[en.target.__t365id] = en.isIntersecting; });
        update();
      }, { threshold: threshold });
      els.forEach(function (el) { el.__t365id = n++; live[el.__t365id] = false; o.observe(el); });
    }
    // tall product tiles: hide as soon as a sliver is on screen. Buttons: hide only when a button is properly in view.
    watch([].slice.call(d.querySelectorAll('.mm-showcase')), 0.04);
    watch([].slice.call(d.querySelectorAll('[data-t365-hide-sticky]')), 0.6);
  }

  // Smooth scroll to the tiles (respect reduced motion).
  d.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#choose"]');
    if (!a) return;
    var t = d.getElementById('choose');
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#choose');
  });
})();
